
<div
    :class="isMove ? 'stamp-move' : ''"
    style="position: absolute" :style="positionStyle" @click="onClick">
    <img
        :key = width
        ref  = "image"
        v-if = "image"
        :src = "image"
        alt  = ""
        style="max-height: 100%; max-width: 100%"
    />
</div>

